var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import ___default from "lodash";
import { createAction, handleActions } from "redux-actions";
function action(actionName, actionPrefix) {
  return (target, propertyKey, descriptor) => {
    const innerActionFunc = target[propertyKey];
    const innerAction = (...args) => innerActionFunc.apply(target, args);
    target[propertyKey] = actionPrefix ? createAction(actionName || `${actionPrefix}_${propertyKey}`, innerAction) : createAction(actionName || propertyKey, innerAction);
  };
}
const aggregateActionKey = "aggregateActionKey";
function aggregateAction() {
  return function(target, propertyKey, descriptor) {
    defineMeta(aggregateActionKey, true, target, propertyKey);
  };
}
function applyDispatch(dispatch, action2, target) {
  return (...args) => dispatch(action2.apply(target, args));
}
function actionClass(prefix = "") {
  return function(constructorFunc) {
    for (const key in constructorFunc.prototype) {
      if (typeof constructorFunc[key] === "function") {
        action()(constructorFunc, key, void 0);
      }
    }
    return class extends constructorFunc {
      constructor(...args) {
        super(...args);
        for (const key of Object.getOwnPropertyNames(Object.getPrototypeOf(this).__proto__)) {
          if (typeof this[key] === "function" && key !== "constructor") {
            const metadata = getMeta(aggregateActionKey, this, key);
            if (!metadata) {
              const explicitActionType = getMeta(actionTypeKey, this, key);
              action(explicitActionType, prefix)(this, key, void 0);
            }
          }
        }
      }
    };
  };
}
const actionTypeKey = "actionType";
function actionType(value) {
  return function(target, propertyKey, descriptor) {
    defineMeta(actionTypeKey, value, target, propertyKey);
  };
}
const noReducerKey = "noReducer";
function noReducer() {
  return function(target, propertyKey, descriptor) {
    defineMeta(noReducerKey, true, target, propertyKey);
  };
}
function createReducer(actions, reducer, defaultState) {
  const mapValues = ___default.keys(actions).filter(
    // filter actions that explicitly should not have a reducer
    (k) => !getMeta(noReducerKey, actions, actions[k].toString())
  ).map((k) => {
    let actionName = actions[k].toString();
    const explicitActionType = getMeta(actionTypeKey, actions, actionName);
    const actionType2 = explicitActionType || actionName;
    return {
      [actionType2](state, action2) {
        if (!reducer[k]) {
          throw new Error(`failed to find reducer ${k}`);
        }
        return reducer[k](state, action2);
      }
    };
  });
  const map = {};
  mapValues.forEach((m) => ___default.extend(map, m));
  return handleActions(map, defaultState);
}
const meta = "meta";
const defineMeta = (metadataKey, metadataValue, target, propertyKey) => {
  var _a;
  if (!!(target == null ? void 0 : target[propertyKey])) {
    target[propertyKey].meta = __spreadProps(__spreadValues({}, (_a = target[propertyKey].meta) != null ? _a : {}), { [metadataKey]: metadataValue });
  }
};
const getMeta = (metadataKey, target, propertyKey) => {
  return ___default.get(target, [propertyKey, meta, metadataKey], void 0);
};
export {
  action,
  actionClass,
  actionType,
  aggregateAction,
  applyDispatch,
  createReducer,
  noReducer
};
//# sourceMappingURL=ReduxDecorators.js.map
